module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-one"
  }, [_c('p', [_vm._v("Component One (should be green)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba9dc88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponentOne.vue
// module id = 313
// module chunks = 2